import { createClient as createSupabaseClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Import the supabase client like this:
// import { supabase } from "@/lib/supabase/client";

function createClient() {
  const client = createSupabaseClient<Database>(
    import.meta.env.VITE_SUPABASE_URL,
    import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY, {
    auth: {
      storage: localStorage,
      persistSession: true,
      autoRefreshToken: true,
    }
  });
  client.realtime.setAuth(); // Needed for Realtime Authorization
  return client;
}

export const supabase = createClient();